/* globals $ Node */
/* eslint-disable */

// TODO work on getting rid of $ from this file!
import cleanPasteHTML, {
  cleanEmptyElementsFactory,
} from '../../util/cleanPasteHTML'
import { contentElementInflate } from '~/modules/routes/storyInflate'
import { splitHTMLAtIndex } from '../../util/htmlAttrs'
import { constants } from '../contenteditablebind/directive'
import { sanitize } from 'dompurify'

const rangy = require('rangy')
// Do not want to deal with scope right now so just using jQuery, will rethink what to do to get broadcast
const broadcastWordCountJQuery = (storyService) => {
  window.setTimeout(() => {
    const elm = $(window.getSelection().anchorNode.closest('[content-element]'))
    const txt = elm.find('[contenteditablebind]').text()
    const ind = elm.prevAll('[content-element]').length
    $(document).trigger('BROADCAST.wc', {
      type: constants.WORDCOUNT,
      orgIndex: ind,
      content: txt.trim().replace(/(&nbsp;|\s)+/g, ' '),
    })
    if (storyService) {
      storyService.pushStoryState()
    }
  }, 100)
}

const isFormElement = (elem) =>
  ['TEXTAREA', 'INPUT', 'SELECT'].indexOf(elem.nodeName) > -1

const getElementIndex = (elem) => {
  const childNodes = elem.parentNode.childNodes
  let cnt = 0
  for (var i = 0; i < childNodes.length; i++) {
    if (childNodes[i] === elem) {
      return cnt
    } else if (
      childNodes[i].nodeType === 1 &&
      childNodes[i].getAttribute('content-element') !== null
    ) {
      cnt++
    }
  }
  return -1
}
let _id = new Date().getTime()

const nextNonANSId = function () {
  _id++
  return _id.toString()
}

// TODO copied from controller..... need to review
function getTextBeforeAfter(container) {
  var sel = window.getSelection()
  var range = sel.getRangeAt(0)
  var tempRange = document.createRange()

  tempRange.selectNodeContents(container)
  tempRange.setEnd(range.startContainer, range.startOffset)
  var before = makeFragment(tempRange, 'before')

  tempRange.selectNodeContents(container)
  tempRange.setStart(range.endContainer, range.endOffset)
  var after = makeFragment(tempRange, 'after')

  const cleanUpContent = (html) => {
    // Sanitize HTML string to prevent XSS
    const sanitizedHTML = sanitize(html)
    const tempElem = $('<div></div>').html(sanitizedHTML.replace(/\n+/, ''))
    tempElem.find('content-tools, .handles, [paste-options], br').remove()
    tempElem.find('[contenteditable]:empty').remove()
    tempElem.find('[contenteditable]').each((i, e) => {
      $(e).contents().unwrap()
    })
    return tempElem
  }

  const beforeElem = cleanUpContent(before)
  const afterElem = cleanUpContent(after)

  cleanPasteHTML(beforeElem)
  cleanPasteHTML(afterElem)

  return {
    before: beforeElem.html().trim(),
    after: afterElem.html().trim(),
  }
}

// TODO copied from controller..... need to review
function makeFragment(range, direction) {
  let wrapperElem = document.createElement('div')
  wrapperElem.contentEditable = 'true'
  let curElem = range.commonAncestorContainer

  // If we are just in the content Edtiable element it is a simple clone
  if (
    curElem &&
    (curElem.contentEditable === 'true' || $(curElem).is('[content-element]'))
  ) {
    // no inine element
    wrapperElem.appendChild(range.cloneContents())
  } else {
    // inline element, get text before
    const isBefore = direction === 'before'

    // get the element the cursor is in and clone that element without the contents
    let prevElem = curElem.cloneNode()
    let lastElem = curElem
    // se the newly created element with the range and append it to the wrapper
    if (prevElem.nodeType === 1) {
      // getting errors here so look to see if we have an element
      prevElem.appendChild(range.cloneContents())
    } else if (prevElem.parentNode) {
      // if it has a parent append it
      prevElem.parentNode.appendChild(range.cloneContents())
    } else if (prevElem.textContent) {
      // else just add the text
      prevElem.textContent =
        prevElem.textContent + (range.cloneContents().textContent || '')
    }
    wrapperElem.appendChild(prevElem)

    // while we have an element reference we need to loop over it and its children
    while (curElem) {
      lastElem = null

      // Find all the siblings of the element and add it to the wrapper
      while (
        (curElem = isBefore ? curElem.previousSibling : curElem.nextSibling)
      ) {
        let nextElem = curElem.cloneNode(true)
        if (isBefore) {
          wrapperElem.insertBefore(nextElem, prevElem)
        } else {
          wrapperElem.appendChild(nextElem)
        }
        if (prevElem.innerHTML === '') prevElem.remove()
        prevElem = nextElem
        lastElem = curElem
      }

      // Now check if the element is nested and not the content editable element
      const parNode = lastElem && lastElem.parentNode
      const isContentEditable = parNode && parNode.contentEditable === 'true'

      // If it is not content editable, than we need to clone the element and append this to the wrapper
      if (lastElem && !isContentEditable) {
        curElem = parNode
        prevElem = parNode.cloneNode()
        prevElem.innerHTML = wrapperElem.innerHTML
        wrapperElem.innerHTML = '' // clear the html since the content is now in the child
        wrapperElem.appendChild(prevElem) // add the new elemenet so we can start to look at its siblings
      }
    }
  }

  return wrapperElem.innerHTML
}

const setActualClipboardData = (textForClipboard) => {
  const ta = document.createElement('textarea')
  ta.value = textForClipboard
  ta.style.opacity = '.1'
  ta.style.position = 'fixed'
  document.body.appendChild(ta)
  ta.select()
  document.execCommand('copy')
  ta.remove()
}

// This will be an object with keys actionType and elements
let ellipsisInternalClipboard = null
let lastClipboard = null

export const walkTreeOffset = (node, cnt) => {
  // Not the fun thing is the startOffset may not be the index in the parent so we need to walk the tree to find out.
  if (!$(node).is('[contentEditable="true"], :input')) {
    const parent = $(node).parent()
    const contents = parent.contents()
    if (contents) {
      for (let i = 0; i < contents.length; i++) {
        if (contents[i] === node) {
          break
        }
        const txt = contents[i].innerText || contents[i].nodeValue || ''
        cnt += txt.length || 0
      }
    }
    return walkTreeOffset(parent[0], cnt)
  }
  return cnt
}

// In some cases there is no need to call parentNode.
const wrappingContainer = (container) =>
  container.nodeType === Node.TEXT_NODE
    ? wrappingContainer(container.parentNode)
    : container

// Handle a triple-click selection case or a case when you end selection at the
// beginning of a new paragraph. In those cases endContainer pointing to the beginning off
// the next contenteditable and this break whole logic.
// Fix by setting end container as the innermost right element inside the same block
// Now triple click select equal to manual select to the end of the line

export function normaliseSelectionRange(selectionRange) {
  if (
    selectionRange.commonAncestorContainer.id === 'story-wrapper' &&
    selectionRange.endOffset === 0
  ) {
    const range = selectionRange.cloneRange()
    let container = wrappingContainer(range.startContainer).closest(
      '[contenteditable="true"]'
    )
    // Get endContainer content-element, which points to the next block
    let endContainerContentElement = wrappingContainer(
      range.endContainer
    ).closest('[content-element]')
    // If we have prev sibling, set it's contenteditable as end container
    if (
      endContainerContentElement &&
      endContainerContentElement.previousElementSibling
    ) {
      const endCandidate = endContainerContentElement.previousElementSibling.querySelector(
        '[contenteditable="true"]'
      )
      container = endCandidate || container
    }
    // Select innermost container for walkTreeOffset() calculation
    while (container.hasChildNodes()) {
      container = container.childNodes[container.childNodes.length - 1]
    }
    range.setEnd(container, container.textContent.length)
    return range
  }
  return null
}

export const placeCaretAfterSelectorWait = (selector) => {
  // if we have any others in play, remove them
  const prvElms = document.querySelectorAll('span[class^="curFocus"]')
  if (prvElms && prvElms.length) {
    prvElms.forEach((el) => {
      if (!el.classList.contains(selector.replace('.', ''))) {
        const contents = $(el).contents()
        if (contents && contents.length) {
          $(el).contents().unwrap()
        } else {
          $(el).remove()
        }
      }
    })
  }

  let cnt = 0
  const lookup = () => {
    cnt++
    const elm = document.querySelector(selector)
    if (elm) {
      placeCaretAfterNode(elm)
      elm.remove()
    } else if (cnt < 200) {
      window.setTimeout(lookup, 10)
    }
  }
  lookup()
}

export const placeCaretAfterNode = (node) => {
  if (typeof window.getSelection !== 'undefined') {
    var range = document.createRange()
    range.setStartAfter(node)
    range.collapse(true)
    var selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
  }
}

function saveRestoreSelectedRange(range) {
  const clone = range.cloneRange()
  return () => {
    const sel = window.getSelection()
    sel.removeAllRanges()
    sel.addRange(clone)
  }
}

function getContentElementsToClipboard(
  ceObj,
  actionType,
  replacementString,
  storyService
) {
  // This is called by oncut or oncopy each requires same basic code
  // oncut removes elements from content_element array
  // oncopy copies the elements and removes identifiers
  const isCut = actionType === 'cut' // or 'copy'
  const isReplace = actionType === 'replace'
  const isEnter = actionType === 'enter'

  if (window.getSelection) {
    // var rSel = rangy.getSelection()
    const sel = window.getSelection()
    if (sel.rangeCount) {
      // for (let i = 0, cnt = sel.rangeCount; i < cnt; i++) {
      // get the element that is selected
      let selectionRange = sel.getRangeAt(0)

      // Restore original selection range if default operation need to be performed ()
      // const restoreSelectionRange = (function restoreSelectionRange (range) {
      //  const clone = range.cloneRange()
      //  return () => {
      //    const sel = window.getSelection()
      //    sel.removeAllRanges()
      //    sel.addRange(clone)
      //  }
      // })(selectionRange)

      const restoreSelectionRange = saveRestoreSelectedRange(selectionRange)

      const currNode = normaliseSelectionRange(selectionRange) || selectionRange

      // get the first and last content elements in the selection
      let selectionStartElem = wrappingContainer(
        currNode.startContainer
      ).closest('[data-index]')
      let selectionEndElem = wrappingContainer(currNode.endContainer).closest(
        '[data-index]'
      )

      let ceStart = $(selectionStartElem).closest('[content-element]')
      let ceEnd = $(selectionEndElem).closest('[content-element]')

      let selectionStartIndex = ceStart.prevAll('[content-element]').length
      let selectionEndIndex = ceEnd.prevAll('[content-element]').length

      if (
        selectionStartIndex === selectionEndIndex &&
        ceStart.data('type') === 'list'
      ) {
        return handleListAction(
          ceObj,
          { isCut, isReplace, isEnter, actionType },
          replacementString
        )
      } else if (selectionStartIndex > selectionEndIndex) {
        var te = selectionStartElem
        var ti = selectionStartIndex

        selectionStartElem = selectionEndElem
        selectionStartIndex = selectionEndIndex

        selectionEndElem = te
        selectionEndIndex = ti
      } else if (isReplace && selectionStartIndex === selectionEndIndex) {
        return false
      }

      if (!isReplace && !isCut && !isEnter) {
        ceObj = ceObj.slice()
      }
      const els = ceStart.parent().find('[content-element]')
      for (let i = selectionStartIndex; i <= selectionEndIndex; i++) {
        const o = ceObj[i]
        if (o && o.content) {
          if (!els.eq(i).find('[contenteditable="true"]').html()) {
            return
          }

          o.content = els
            .eq(i)
            .find('[contenteditable="true"]')
            .html()
            .replace('<i></i><b></b>', '')
        }
      }

      // Check to see if the start/end selections is part of the text or all of it....
      let leadOffset = walkTreeOffset(
        currNode.startContainer,
        currNode.startOffset
      )
      let tailOffset = walkTreeOffset(currNode.endContainer, currNode.endOffset)

      // If they are in the SAME element than determine if the user selected all the text or just a partial amount
      if (selectionStartIndex === selectionEndIndex) {
        // Check to see if all the text is selected or if it is just a partial selection
        // If it is not all, than we just let content editable do its thing
        if (
          leadOffset !== 0 ||
          tailOffset !== selectionStartElem.textContent.length
        ) {
          restoreSelectionRange()
          return false
        }
      }

      const cloneCE = (index, offset, startEnd, alterOrg) => {
        const original = typeof index === 'object' ? index : ceObj[index]
        const cloned = Object.assign({}, original)
        delete cloned.$$hashKey
        // see if we are not a media element
        if (['image', 'gallery', 'video'].indexOf(cloned.type) === -1) {
          delete cloned._id // Remove ANS ID
        }
        if (cloned.additionalProperties) {
          // change our internal tracking id
          cloned.additionalProperties._id = nextNonANSId()
        }

        if (offset !== undefined) {
          // Get the HTML for the front and back half of the string
          const partialHTML = splitHTMLAtIndex(original.content, offset)

          if (startEnd === 'start') {
            if (alterOrg) {
              original.content = partialHTML.lead // original.content.substr(0, offset)
            }
            cloned.content = partialHTML.tail // cloned.content.substr(offset)
          } else {
            // 'end'
            if (alterOrg) {
              original.content = partialHTML.tail // original.content.substr(offset)
            }
            cloned.content = partialHTML.lead // cloned.content.substr(0, offset)
          }
        }

        return {
          original,
          cloned,
        }
      }

      // TODO see if start and end are the full element or just partial
      let leadCE = null
      let tailCE = null
      // cut action
      if (isCut || isReplace || isEnter) {
        const selRestore1 = saveRestoreSelectedRange(
          window.getSelection().getRangeAt(0)
        )

        let cutBeforeAdj = 0
        let cutAfterAdj = 0

        if (leadOffset !== 0) {
          cutBeforeAdj = 1
          leadCE = cloneCE(selectionStartIndex, leadOffset, 'start', true)
        }

        if (tailOffset !== currNode.endContainer.length) {
          cutAfterAdj = 1
          tailCE = cloneCE(selectionEndIndex, tailOffset, 'end', true)
        }

        if (isReplace) {
          cutAfterAdj = 0

          let attempts = 0
          const setCur = () => {
            var el = document.querySelector('i>b>u')
            if (el) {
              placeCaretAfterNode(el)
              el.parentNode.parentNode.remove()
            } else if (attempts < 750) {
              window.setTimeout(setCur, 1)
              attempts++
            }
          }
          // Clear all leftovers, if any
          document
            .querySelectorAll('i>b>u')
            .forEach((e) => e.parentNode.parentNode.remove())
          if (leadCE) {
            const ld = leadCE.original.content
            leadCE.original.content =
              ld +
              replacementString +
              '<i><b><u></u></b></i>' +
              (tailCE && tailCE.original ? tailCE.original.content : '')
            tailCE = null
            ceObj.splice(selectionStartIndex, 1, leadCE.original)
          } else if (tailCE) {
            tailCE.original.content =
              '<i><b><u></u></b></i>' + tailCE.original.content
            cutAfterAdj = 1
          } else {
            attempts = 1000
          }
          setCur()
        }

        // get the ANS objects and copy them to our interanl clipboard, not the browsers....
        // const elementsCut = ceObj.splice(selectionStartIndex + cutBeforeAdj, selectionEndIndex - selectionStartIndex + 1 - cutBeforeAdj - cutAfterAdj)

        // get the ANS objects and copy them to our interanl clipboard, not the browsers....
        const elementsCut = ceObj
          .slice(0)
          .splice(
            selectionStartIndex + cutBeforeAdj,
            selectionEndIndex -
              selectionStartIndex +
              1 -
              cutBeforeAdj -
              cutAfterAdj
          )

        window.setTimeout(() => {
          ceObj.splice(
            selectionStartIndex + cutBeforeAdj,
            selectionEndIndex -
              selectionStartIndex +
              1 -
              cutBeforeAdj -
              cutAfterAdj
          )
          broadcastWordCountJQuery(storyService)
        }, 10)

        if (leadCE) {
          elementsCut.unshift(leadCE.cloned)
        }

        if (tailCE) {
          elementsCut.push(tailCE.cloned)
        }

        if (isCut) {
          selRestore1()
          ellipsisInternalClipboard = {
            actionType,
            elements: JSON.parse(JSON.stringify(elementsCut)),
          }

          const plnTxt = window.getSelection().toString()
          lastClipboard = plnTxt
          setActualClipboardData(plnTxt)
          return false
        }
        // TODO need to fire something here to make sure history is updated
      } else {
        // copy action
        let copyBeforeAdj = 0
        let copyAfterAdj = 0

        const selRestore = saveRestoreSelectedRange(
          window.getSelection().getRangeAt(0)
        )

        if (leadOffset !== 0) {
          copyBeforeAdj = 1
          leadCE = cloneCE(selectionStartIndex, leadOffset, 'start', false)
        }

        if (tailOffset !== currNode.endContainer.length) {
          copyAfterAdj = 1
          tailCE = cloneCE(selectionEndIndex, tailOffset, 'end', false)
        }

        let start = selectionStartIndex + copyBeforeAdj
        let end = selectionEndIndex - copyAfterAdj

        // Copy the elements from ANS that are selected
        const elementsCopied = ceObj.slice(start, end + 1)

        if (leadCE) {
          elementsCopied.unshift(leadCE.cloned)
        }

        if (tailCE) {
          elementsCopied.push(tailCE.cloned)
        }

        selRestore()

        // since it is a copy, clean up ids for elements where id does not reference an object
        var copiedItems = elementsCopied.map((ceOrg) => cloneCE(ceOrg).cloned)
        ellipsisInternalClipboard = {
          actionType,
          elements: copiedItems,
        }
      }

      if (ellipsisInternalClipboard) {
        const actionText = isCut ? 'moved' : 'copied'
        console.info(
          `${ellipsisInternalClipboard.elements.length} item(s) ${actionText} to clipboard`
        )
      }

      return true
    }
  }
}

export const handleCutCopy = (scope, storyService, evt) => {
  // If it is a form element, than let it be
  if (isFormElement(evt.target)) {
    return true
  }

  const cutResultOverridden = getContentElementsToClipboard(
    scope.story.content_elements,
    evt.type,
    storyService
  )
  console.info('cutResultOverridden', cutResultOverridden)
  // from previous fix, if no delay, it might have wrong count
  broadcastWordCountJQuery(storyService)
  if (cutResultOverridden) {
    // evt.preventDefault()
    // set clipboard data so we know if user changed it since we recorded it.

    lastClipboard = window.getSelection().toString()

    return true
    // setActualClipboardData(lastClipboard)
    // return false
  } else {
    return true
  }
}

export const handleRemove = (scope, storyService, event, key) => {
  var result = getContentElementsToClipboard(
    scope.story.content_elements,
    'replace',
    key
  )
  if (result) {
    event.preventDefault()
    broadcastWordCountJQuery(storyService)
    return false
  } else {
    return true
  }
}

export const handleEnterSelection = (scope, storyService, event) => {
  var result = getContentElementsToClipboard(
    scope.story.content_elements,
    'enter'
  )
  if (result) {
    event.preventDefault()
    broadcastWordCountJQuery(storyService)
    return false
  } else {
    return true
  }
}

export const getTextBeforeAfterCursor = (content) => {
  const leadOffset = getCurrentCursorIndex()
  return leadOffset ? splitHTMLAtIndex(content, leadOffset) : null
}

export const getCurrentCursorIndex = function () {
  const sel = window.getSelection()
  if (sel && sel.rangeCount > 0) {
    const currNode = sel.getRangeAt(0)
    if (currNode) {
      return walkTreeOffset(currNode.startContainer, currNode.startOffset)
    }
  }
  return null
}

export const handlePaste = (
  scope,
  contentTemplatesService,
  storyService,
  evt
) => {
  // If we have a form element in focus, than exit out
  if (isFormElement(evt.target)) {
    return true
  }

  let clipboardData = evt.originalEvent.clipboardData || window.clipboardData
  let pastedDataText = clipboardData.getData('Text')
  // let pastedDataHtml = clipboardData.getData('text/html')

  let pasteResult
  if (pastedDataText === lastClipboard) {
    pasteResult = internalClipboardPaste(scope, evt)
  } else {
    // make sure clipboard is not the Ellipsis time stamp....
    // need code to handle normal submit???
    pasteResult = externalClipboardPaste(scope, contentTemplatesService, evt)
  }
  // from previous fix, if no delay, it might have wrong count
  broadcastWordCountJQuery(storyService)
  return pasteResult
}

function internalClipboardPaste(scope, evt) {
  if (ellipsisInternalClipboard) {
    // deal with selection
    var lSel = window.getSelection()
    const aNode = lSel.anchorNode
    const an = aNode.parentElement.closest('[content-element]')

    const clipItems = JSON.parse(
      JSON.stringify(ellipsisInternalClipboard.elements)
    )
    if (ellipsisInternalClipboard.wasPasted) {
      clipItems.forEach((itm) => {
        // make copied items unique if already pasted once
        if (itm.additionalProperties) {
          itm.additionalProperties._id = nextNonANSId()
        }
        delete itm._id
        delete itm.$$hashKey
      })
    }

    if (an.dataset.type === 'list') {
      handleListPastePlainText(an, evt.target, scope, '', clipItems)
      return false
    }

    if (lSel.toString().length) {
      const eNode = lSel.extentNode
      const en = eNode.parentElement.closest('[content-element]')

      if (an !== en) {
        var anText = getTextBeforeAfter(an)
        var enText = getTextBeforeAfter(en)
        var ce = scope.story.content_elements

        var startIndex = $(an).index() - 1
        var endIndex = $(en).index() - 1

        if (startIndex > endIndex) {
          var temp = anText
          anText = enText
          enText = temp
          temp = startIndex
          startIndex = endIndex
          endIndex = temp
        }

        if (anText.before.length) {
          if (ce[startIndex].content) {
            ce[startIndex].content = anText.before
          }
          startIndex += 1
        }

        if (enText.after.length) {
          if (ce[endIndex].content) {
            ce[endIndex].content = enText.after
          }
          endIndex -= 1
        }
        ce.splice(startIndex, endIndex - startIndex + 1)
      }
    }

    pasteANSObjects(scope, evt, clipItems)
    ellipsisInternalClipboard.wasPasted = true
  }
  return false
}

function pasteANSObjects(scope, evt, clipItems) {
  const contentElems = scope.story.content_elements

  // get the active content element and index
  let focusedFeature = evt.target.closest('[ng-model="feature"]')
  const focusedIndex = getElementIndex(focusedFeature)

  // if nothing is selected, not sure how we are supposed to know where to paste
  if (!focusedFeature || focusedIndex === -1) {
    return true
  }

  const editable = evt.target.closest('[contenteditable="true"')

  if (
    focusedFeature.getAttribute('data-type') === 'list' &&
    clipItems.length === 1 &&
    clipItems[0].type === 'list'
  ) {
    handleListAction(contentElems, { isReplace: true }, clipItems)
    return false
  } else {
    return setContentElements(contentElems, clipItems, editable, focusedIndex)
  }
}

function generateCursorLocation() {
  const ts = 'curFocus' + new Date().getTime()
  return {
    html: `<span class='${ts}'></span>`,
    watch: () => {
      placeCaretAfterSelectorWait('.' + ts)
    },
  }
}

function setContentElements(
  contentElems,
  clipItems,
  focusedElem,
  focusedIndex
) {
  var selection = window.getSelection()

  let startContainer = selection.baseNode.parentNode.closest(
    '[content-element]'
  ) // || featureOrTextObj || {}
  let endContainer = selection.extentNode.parentNode.closest(
    '[content-element]'
  ) // || featureOrTextObj || {}

  let startIndex = $(startContainer).index()
  let endIndex = $(endContainer).index()
  let anchorOffset = selection.anchorOffset
  let extentOffset = selection.extentOffset
  let anchorNode = selection.anchorNode
  let extentNode = selection.extentNode
  var curFocus = generateCursorLocation()

  if (
    startIndex > endIndex || // swap because selection from bottom to top
    (startIndex === endIndex && anchorOffset > extentOffset)
  ) {
    // swap because bottom to top in same element
    let temp
    temp = startContainer
    startContainer = endContainer
    endContainer = temp
    temp = anchorNode
    anchorNode = extentNode
    extentNode = temp
    temp = anchorOffset
    anchorOffset = extentOffset
    extentOffset = temp
    temp = startIndex
    startIndex = endIndex
    endIndex = temp
  }

  startContainer = $(startContainer).closest('[content-element]')
  endContainer = $(endContainer).closest('[content-element]')

  const hasSelection = selection.toString().length

  let adjustIndex = 0
  let removeCount = 0
  const currentCursorText = getTextBeforeAfter(focusedElem)

  const updateSelectionSameElem = () => {
    adjustIndex = 1
    contentElems[focusedIndex].content = currentCursorText.before
    const elm = Object.assign({}, contentElems[focusedIndex])
    delete elm._id
    delete elm.$$hashKey
    if (elm.additional_properties && elm.additional_properties.id) {
      elm.additional_properties.id = nextNonANSId()
    }
    elm.content = curFocus.html + currentCursorText.after
    clipItems.push(elm) // NEED TO ADD THE CURSOR CODE HERE
    curFocus.watch()
  }

  if (!hasSelection) {
    // We have no selection
    let addToLast = false
    if (
      currentCursorText.before.length === 0 &&
      currentCursorText.after.length === 0
    ) {
      // replace current
      removeCount = 1
      addToLast = true
    } else if (currentCursorText.before.length === 0) {
      // add before
      adjustIndex = 0
      addToLast = true
    } else if (currentCursorText.after.length === 0) {
      // add after
      adjustIndex = 1
      addToLast = true
    } else {
      // it be in the middle with no selection
      updateSelectionSameElem()
    }

    if (addToLast) {
      const last = clipItems[clipItems.length - 1]
      if (last.content) {
        last.content += curFocus.html
        curFocus.watch()
      }
    }
  } else if (startIndex === endIndex) {
    // selection inside same element
    if (currentCursorText.before.length === 0) {
      // add before
      adjustIndex = 0
      contentElems[focusedIndex].content = currentCursorText.after
      // NEED TO ADD THE CURSOR CODE HERE
    } else if (currentCursorText.after.length === 0) {
      // add after
      adjustIndex = 1
      contentElems[focusedIndex].content = currentCursorText.before
      const last1 = clipItems[clipItems.length - 1]
      if (last1.content) {
        last1.content += curFocus.html
        curFocus.watch()
      }
    } else {
      // it be in the middle with no selection
      updateSelectionSameElem()
    }
  } else {
    // selection over mutliple elements
    var aText = getTextBeforeAfter(startContainer[0]).before
    var eText = getTextBeforeAfter(endContainer[0]).after

    removeCount = endIndex - startIndex + 1

    if (aText.length) {
      adjustIndex = 1
      removeCount--
      contentElems[startIndex - 1].content = aText
    }

    if (eText.length) {
      contentElems[endIndex - 1].content = eText
      removeCount--
    }
  }

  Array.prototype.splice.apply(
    contentElems,
    [focusedIndex + adjustIndex, removeCount].concat(clipItems)
  )

  return false
}

/** THIS IS TEMP ***/
const urlWithSchemeRegex = /^(mailto:|https?:\/{2}|\/{2})(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
const urlWithoutSchemeRegex = /^[-a-zA-Z0-9@:%_+.~#?&=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$/gi

/** THIS IS TEMP ***/
const isValidUrlWithScheme = (url) => {
  return new RegExp(urlWithSchemeRegex).test(url)
}
/** THIS IS TEMP ***/
const isValidUrlWithoutScheme = (url) => {
  return new RegExp(urlWithoutSchemeRegex).test(url)
}

/** THIS IS TEMP ***/
const getValidUrl = (url) => {
  if (isValidUrlWithScheme(url)) {
    return url
  } else if (isValidUrlWithoutScheme(url)) {
    return '//' + url
  }

  return null
}

function externalClipboardPaste(scope, contentTemplatesService, evt) {
  let clipboardData = evt.originalEvent.clipboardData || window.clipboardData
  let pastedDataText = clipboardData.getData('Text')
  let pastedDataHtml = clipboardData.getData('text/html')
  // plain text in our case has line breaks, if there are none, we just let the default action happen
  let isPlainText =
    !pastedDataHtml && pastedDataText && pastedDataText.indexOf('\n') > -1

  let focusedFeature = evt.target.closest('[ng-model="feature"]')
  const elemType = focusedFeature
    ? focusedFeature.getAttribute('data-type')
    : 'text'

  var pastedANS = []

  /* we need to figure out how to pass this in....
  const validUrl = hyperlinkService.getValidUrl(pastedDataText)
  */

  const validUrl = getValidUrl(pastedDataText)
  if (validUrl) {
    const validUrl = getValidUrl(pastedDataText)
    var rSel = rangy.getSelection()

    // Check to see if we have a selection if we do, than we create a link with createLink
    let createLinkAction = !rSel.isCollapsed
    // If we do not have a selection, lets see if we can make a selection
    // for the user (aka the cursor is in the middle of a word)
    if (
      rSel.isCollapsed &&
      window.getSelection().anchorNode.textContent.length
    ) {
      // bookmark the current position to make sure we have the ability to undo word selection
      const savedSel = rangy.saveSelection()
      // try to select the word
      rSel.expand('word')

      // Check to see if rangy was able to select the word
      let selectionLength = rSel.text().trim().length

      // ignore if selection is just punctuation
      if (selectionLength === 1) {
        selectionLength = rSel.text().trim().match(/\b/) ? selectionLength : 0
      }

      createLinkAction = selectionLength > 0
      // If we have no words selected, we need to move cursor back to where it is
      // the word selection can select a new line character if at the end.
      // that results in some fun layout issues if it is selected with the
      if (selectionLength === 0) {
        rangy.restoreSelection(savedSel)
      }
      // remove marker since it is no longer required
      rangy.removeMarkers(savedSel)
    }

    const hasTarget = window.org_settings.setAnchorsToBlank

    // So we either create a link on the selected text or we build a link using the link text
    if (createLinkAction) {
      // call create link to turn selection into a link
      document.execCommand('createlink', false, validUrl)
      // if we have to open it in new window by default, set the attribute
      if (hasTarget) {
        const curLink = document.getSelection().anchorNode.parentElement
        curLink.setAttribute('target', '_blank')
      }
    } else {
      // nothing is selected so we need to build the HTML
      const targetAttr = hasTarget ? ' target="_blank"' : ''
      const anchorHTML = ` <a href="${pastedDataText}" ${targetAttr}>${pastedDataText}</a> `
      document.execCommand('insertHTML', false, anchorHTML)
    }
    // exit out since we handled the paste action
    return false
  }

  // If we have html pasted in on clipboard, parse it into ANS objects based on sniffing element types
  if (pastedDataHtml) {
    cleanHTML(
      pastedDataHtml,
      pastedANS,
      cleanEmptyElementsFactory({}),
      contentTemplatesService
    )
  }

  if (elemType === 'list') {
    // if a list item is in focus, lets make a list items from the data
    return handleListPastePlainText(
      focusedFeature,
      evt.target,
      scope,
      pastedDataText,
      pastedANS
    )
  } else if (isPlainText) {
    // Plain text with just line breaks
    // TODO FUTURE - support basic MARKDOWN language within this
    pastedANS = []
    // break on line feeds and convert into paragraphs
    const lineBreaks = /\r?\n/g
    const paras = pastedDataText.split(lineBreaks)
    for (let i = 0; i < paras.length; i++) {
      const txt = $.trim(paras[i])
      if (txt.length) {
        const paraElem = basicMarkdown(txt, i, paras)
        processElem(
          paraElem,
          pastedANS,
          cleanEmptyElementsFactory({}),
          contentTemplatesService
        )
      }
    }
  } else if (pastedDataHtml) {
    // rawHTML, pastedObjects, cleanEmptyElements
  }

  if (pastedANS.length) {
    pasteANSObjects(scope, evt, pastedANS)
    return false
  } else if (pastedDataHtml.indexOf('style=') > -1) {
    const elmHTML = $('<div></div>').html(pastedDataHtml)
    cleanPasteHTML(elmHTML)
    document.execCommand('insertHTML', false, elmHTML.html())
    return false
  }
  return true
}

function basicMarkdown(txt, ind, arr) {
  const heading = txt.match(/^(#+)\s(.+)$/)
  const blockquote = txt.match(/^(>)\s(.+)$/)
  // eslint-disable-next-line no-useless-escape
  const interstial = txt.match(/^\[([^\]]+)\]\(([^\)]+)\)$/)
  const unordered = txt.match(/^(\*)\s(.+)$/)
  const ordered = txt.match(/^(\d+\.)\s(.+)$/)

  if (heading) {
    const level = heading[1].split('#').length - 1
    return $(`<h${level}>${heading[2]}</h${level}>`)
  }

  if (blockquote) {
    return $(`<blockquote>${blockquote[2]}</blockquote>`)
  }

  if (interstial) {
    return $(`<p><i><a href="${interstial[2]}">${interstial[1]}</a></i></p>`)
  }

  let test
  let items

  if (unordered) {
    test = true
    items = [unordered[2]]
    while (test && arr[ind + 1]) {
      test = arr[ind + 1].match(/^(\*)\s(.+)$/)
      if (test) {
        items.push(test[2])
        arr.splice(ind + 1, 1)
      }
    }
    return $('<ul><li>' + items.join('</li><li>') + '</li></ul>')
  }

  if (ordered) {
    test = true
    items = [ordered[2]]
    while (test && arr[ind + 1]) {
      test = arr[ind + 1].match(/^(\d+\.)\s(.+)$/)
      if (test) {
        items.push(test[2])
        arr.splice(ind + 1, 1)
      }
    }
    return $('<ol><li>' + items.join('</li><li>') + '</li></ol>')
  }

  return $('<p></p>').text(txt)
}

function handleListPastePlainText(listFeature, target, scope, text, htmlANS) {
  const focusedIndex = getElementIndex(listFeature)
  const listAnsObj = scope.story.content_elements[focusedIndex]

  const activeLi = target.closest('li')
  const children = Array.from(activeLi.parentNode.children)
  let liIndex = -1
  for (let i = 0; i < children.length; i++) {
    if (children[i] === activeLi) {
      liIndex = i
      break
    }
  }

  let clipItems = []

  // Takes the ANS from the other html elements and see if it can get text from it
  // In the future we should be able to handle more types of content in list other than text
  const convertToText = (ces) => {
    ces.forEach((ce) => {
      if (ce.content) {
        clipItems.push({ type: 'text', content: ce.content })
      } else if (ce.items) {
        convertToText(ce.items)
      }
    })
  }

  // If we have HTML passed in, than lets parse out the text
  if (htmlANS.length) {
    convertToText(htmlANS)
  } else if (text.indexOf('\n') > -1) {
    // We have plain text so lets try to break it up and create new elements
    const lineBreaks = /\r?\n/g
    const lines = text.split(lineBreaks)
    clipItems = lines.map((content) => ({ type: 'text', content }))
  } else {
    var sel = window.getSelection()
    var x = getTextBeforeAfter(activeLi)
    if (sel.toString().length && !x.before.length && !x.after.length) {
      activeLi.innerHTML = text
      return false
    } else {
      return true
    }
  }

  return setContentElements(listAnsObj.items, clipItems, activeLi, liIndex)
}

// TODO We really should not be passing contentTemplatesService around.....

// TODO copied from controller..... need to review
// Method takes an HTML element and builds the ANS for that HTML element
function processElem(
  elem,
  ansArr,
  cleanEmptyElements,
  contentTemplatesService
) {
  let elemANS = null
  let type

  if (elem) {
    // remove the spans, they are used by emails/webpages to force styles typically
    elem.find('span').contents().unwrap()

    cleanEmptyElements(elem)
    if (elem.data('deleted')) {
      elem.remove()
      return
    }
    const tagName = (elem.prop('tagName') || '').toLowerCase()
    if (tagName === 'p' || (tagName === 'div' && !elem.children().length)) {
      // This is checking to see if someone pasted from washpost page that has the interstial link
      // TODO: find other patterns for interstial links and see if we can match those
      type =
        elem.has('> i > a').length &&
        elem.children().length === 1 &&
        !elem.has('image').length
          ? 'interstitial_link'
          : 'text'
    } else if (tagName.match(/h\d/i)) {
      type = 'header'
    } else if (tagName === 'blockquote') {
      type = 'blockquote'
    } else if (tagName === 'ul' || tagName === 'ol') {
      type = 'list'
    } else if (elem.has('> table').length) {
      type = 'table'
    } else if (tagName === 'twitterwidget') {
      var status = elem.find('a').eq(0).attr('href').replace(/[“”]/g, '')
      elemANS = {
        type: 'oembed_response',
        subtype: 'twitter',
        _id: '',
        referent: {
          id: status,
          type: 'twitter',
          service: 'oembed',
          provider: 'https://publish.twitter.com/oembed?url=',
        },
      }
    } else if (elem.has('> iframe[src*="youtube.com/embed"]').length) {
      const src = elem.find('iframe').attr('src')
      if (src && src.length) {
        elemANS = {
          type: 'oembed_response',
          subtype: 'facebook',
          _id: '',
          referent: {
            id: src,
            type: 'youtube',
            service: 'oembed',
            provider: 'https://www.youtube.com/oembed?url=',
          },
        }
      } else {
        return
      }
    } else if (elem.children().length) {
      elem.children().each(function () {
        processElem(
          $(this),
          ansArr,
          cleanEmptyElements,
          contentTemplatesService
        )
      })
      return
    } else {
      return
    }

    elemANS =
      elemANS || contentTemplatesService.getOnPasteConversion(type, elem)

    elemANS = contentElementInflate(elemANS)

    if (elemANS) {
      ansArr.push(elemANS)
    }
  }

  return false
}

const handleListAction = (ceObj, actions, replacement) => {
  var lSel = window.getSelection()
  const aNode = lSel.anchorNode
  const eNode = lSel.extentNode
  const anLi =
    aNode.tagName === 'LI' ? aNode : aNode.parentElement.closest('li')
  const enLi =
    eNode.tagName === 'LI' ? eNode : eNode.parentElement.closest('li')

  const lStart = walkTreeOffset(aNode, lSel.anchorOffset)
  const lEnd = walkTreeOffset(eNode, lSel.extentOffset)
  const lHTMLStart = splitHTMLAtIndex(anLi.innerHTML, lStart)
  const lHTMLEnd = splitHTMLAtIndex(enLi.innerHTML, lEnd)
  const anIndex = $(anLi).prevAll('li').length
  const enIndex = $(enLi).prevAll('li').length
  const elementIndex = $(anLi)
    .closest('[content-element]')
    .prevAll('[content-element]').length
  const ulObjItems = ceObj[elementIndex].items
  const ts = 'curFocus' + new Date().getTime()
  let removeCount = 0
  let appendItems
  let requiredFocus = false
  if (actions.isCut || actions.isEnter) {
    ulObjItems[anIndex].content = lHTMLStart.lead
    ulObjItems[enIndex].content = `<span class='${ts}'></span>` + lHTMLEnd.tail
    removeCount = enIndex - anIndex
    requiredFocus = true
  } else if (actions.isReplace && typeof replacement === 'string') {
    ulObjItems[anIndex].content =
      lHTMLStart.lead +
      replacement +
      `<span class='${ts}'></span>` +
      lHTMLEnd.tail
    removeCount = enIndex - anIndex + 1
    requiredFocus = true
  } else if (actions.isReplace) {
    ulObjItems[anIndex].content = lHTMLStart.lead
    ulObjItems[enIndex].content = `<span class='${ts}'></span>` + lHTMLEnd.tail
    removeCount = enIndex - anIndex
    requiredFocus = true
    appendItems = replacement[0].items
  }

  // helper to make the li item
  const createLi = (content, _id = '', additionalProperties = {}) => {
    if (additionalProperties.id) {
      additionalProperties.id = nextNonANSId()
    }
    return { _id, type: 'text', content, additionalProperties }
  }

  if (!actions.isReplace) {
    if (enIndex === anIndex && lHTMLEnd.lead.length && lHTMLEnd.tail.length) {
      return false
    }

    // clone the orginal list
    const clip = Object.assign({}, ceObj[elementIndex])
    // clean up angular
    delete clip.$$hashKey
    if (clip.additionalProperties && clip.additionalProperties.id) {
      clip.additionalProperties.id = nextNonANSId()
    }
    clip.items = []
    clip.items.push(createLi(lHTMLStart.tail, ''))
    for (let i = 1; i < enIndex - anIndex; i++) {
      const itm = ulObjItems[anIndex + i]
      const id = actions.isCut ? itm._id : ''
      clip.items.push(createLi(itm.content, id, itm.additionalProperties))
    }
    if (enIndex !== anIndex && lHTMLEnd.lead.length) {
      clip.items.push(createLi(lHTMLEnd.lead, ''))
    }

    ellipsisInternalClipboard = {
      actionType: actions.actionType,
      elements: [clip],
    }
  }

  if (appendItems) {
    Array.prototype.splice.apply(
      ulObjItems,
      [anIndex + 1, removeCount - 1].concat(appendItems)
    )
  } else if (removeCount > 1) {
    ulObjItems.splice(anIndex + 1, removeCount - 1)
  }
  if (requiredFocus) {
    placeCaretAfterSelectorWait('.' + ts)
  }
  return true
}

// TODO copied from controller..... need to review
function cleanHTML(
  rawHTML,
  pastedObjects,
  cleanEmptyElements,
  contentTemplatesService
) {
  const temp$ = $(`<div>${rawHTML}</div>`)
  const originalHTML = temp$.html()
  cleanPasteHTML(temp$)
  temp$.children().each(function () {
    processElem(
      $(this),
      pastedObjects,
      cleanEmptyElements,
      contentTemplatesService
    )
  })
  const cleanedHTML = temp$.html()
  const hasUpdated = cleanedHTML !== originalHTML
  return {
    cleanedHTML,
    hasUpdated,
  }
}

export const findFocusCursor = (selector = 'span.cursor-focus') => {
  let cfTimer = null
  const lookForCursorFocus = (cnt) => {
    if (!cnt) {
      cnt = 1
    }
    if (cfTimer) {
      window.clearTimeout(cfTimer)
    }
    const cf = document.querySelector(selector)
    if (cf) {
      const pe = cf.closest('[contenteditablebind]')
      if (pe) {
        pe.blur()
      }
      cf.focus()
      const range = document.createRange()
      range.setStartAfter(cf)
      range.collapse(true)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      cf.remove()
    } else if (cnt < 1000) {
      cfTimer = window.setTimeout(lookForCursorFocus, 5, cnt++)
    }
  }
  lookForCursorFocus()
}
